import ListLayoutManager from './ListLayoutManager'
import ResponsiveProperty from '../data/ResponsiveProperty'

interface FlexGridLayoutManagerOptions {
    columns: ResponsiveProperty
}

class FlexGridLayoutManager extends ListLayoutManager {

    options: FlexGridLayoutManagerOptions

    constructor(itemGrid) {
        super(itemGrid)
        this.options = itemGrid.data('options')
    }

    getCustomStyles(wrapper: string) {
        const colsM = this.options.columns.mobile.value
        const colsT = this.options.columns.tablet.value
        const colsD = this.options.columns.desktop.value
        const breakT = this.options.columns.tablet.breakpoint
        const breakD = this.options.columns.desktop.breakpoint
        return `
        ${wrapper} .dynamic-post-grid.flex_grid > .grid-item {
            width: ${100 / colsM}%;
        }
        @media (min-width: ${breakT}px) {
        ${wrapper} .dynamic-post-grid.flex_grid > .grid-item {
            width: ${100 / colsT}%;
        }
        }
        @media (min-width: ${breakD}px) {
        ${wrapper} .dynamic-post-grid.flex_grid > .grid-item {
            width: ${100 / colsD}%;
        }
        }
        `
    }
}

export default FlexGridLayoutManager